import React, { useState } from 'react';
import { Menu, Input, Empty, Affix } from 'antd';
import { MessageOutlined, UserOutlined, PlusOutlined, SearchOutlined, ConsoleSqlOutlined, UsergroupAddOutlined } from '@ant-design/icons';

const ChatSidebar = ({
  people,
  onSelectUser,
  onAddGroup,
  groups,
  onSelectGroup,
  recentDirectChats,
  currentUserId,
  setIsDirectChat,
  setIsGroupChat,
  setChatType,
  chatType


}) => {
  const [showSearchBox, setShowSearchBox] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedChatIndex, setSelectedChatIndex] = useState(null); // State to track the selected chat
  const [selectedChatId, setSelectedChatId] = useState(null); // Track the selected user's ID


  // Filter people based on search term
  const filteredPeople = people.filter((person) =>
    person.Name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleChatClick = (userId, otherUser) => {
    setChatType('direct');
    setSelectedChatIndex(userId); // Set the selected chat index
    setSelectedChatId(userId); // 
    onSelectUser(otherUser); // Trigger the onSelectUser function
  };

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#ffffff', borderRight: '1px solid #f0f0f0' }}>
      <Affix offsetTop={0}>
        <h2 style={{ textAlign: 'center', padding: '10px 0', margin: 0, backgroundColor: '#fff', zIndex: 1 }}>
          Aptclouds
        </h2>
      </Affix>
      <div
        style={{
          backgroundColor: '#ffffff',
          borderRight: '1px solid #f0f0f0',
          overflowY: 'scroll',
          maxHeight: '700px',
          flexGrow: 1,
          scrollbarWidth: 'thin',
          scrollbarColor: '#d4d4d4 transparent',
        }}
      >
        <style>
          {`
      div::-webkit-scrollbar {
        width: 4px;
      }
      div::-webkit-scrollbar-thumb {
        background: #d4d4d4;
        border-radius: 2px;
      }
      div::-webkit-scrollbar-track {
        background: transparent;
      }
    `}
        </style>


        <Menu
          defaultOpenKeys={['Groups', 'people']} 
          mode="inline" 
          defaultSelectedKeys={['general']}
          style={{ borderRight: 0 }}>
          <Menu.SubMenu key="Groups" title="Groups" icon={<UsergroupAddOutlined />} >
            <Menu.Item key="add-group" icon={<PlusOutlined />} onClick={onAddGroup}>
              Add Group
            </Menu.Item>
            {groups.length > 0 ? (
              groups.map((group) => (
                <Menu.Item key={group._id} onClick={() => {
                  setChatType('group');
                  setSelectedChatIndex(null);
                  onSelectGroup(group)
                }}>
                  {group.name}
                </Menu.Item>
              ))
            ) : (
              <Menu.Item disabled>No groups available</Menu.Item>
            )}
          </Menu.SubMenu>
          <Menu.SubMenu
            key="people"
            title={
              <span>
                <UserOutlined style={{ marginRight: '8px' }} />
                Direct Messages
              </span>
            } 
          >
            <Menu.Item
              key="add-user"
              icon={<PlusOutlined />}
              onClick={() => setShowSearchBox((prev) => !prev)}
            >
              Add User
            </Menu.Item>
            {showSearchBox && (
              <div style={{ padding: '10px' }}>
                <Input
                  prefix={<SearchOutlined />}
                  placeholder="Search for people..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value)
                  }
                  }

                />
                <div style={{ marginTop: '10px', padding: 'auto', margin: 'auto', minHeight: 'auto', overflowY: 'auto' }}>
                  {searchTerm && filteredPeople.length > 0 ? (
                    filteredPeople.map((person) => (
                      <div
                        key={person._id}
                        style={{
                          padding: '15px 15px',
                          cursor: 'pointer',
                          borderBottom: '1px solid #f0f0f0',
                          backgroundColor: selectedChatId === person._id ? '#e6f7ff' : 'transparent', // Highlight selected chat

                        }}
                        onClick={(index) => {
                          setShowSearchBox(false);
                          setSearchTerm('');
                          handleChatClick(person._id, person);
                        }
                        }
                      >
                        {person.Name}
                      </div>
                    ))
                  ) : searchTerm ? (
                    <Empty description="No users found" />
                  ) : null}

                </div>


              </div>
            )}
            <div style={{ marginTop: '20px' }}>
              {recentDirectChats?.length > 0 ? (
                recentDirectChats?.map((chat, index) => {
                  const otherUserId = chat.user_ids.find(id => id !== currentUserId); // Find the user ID that is not the currentUserId
                  const otherUser = chat.users.find((person) => person._id === otherUserId); // Get the user's data by matching ID
                  return (
                    otherUser && (
                      <Menu.Item
                        key={index}
                        style={{
                          padding: '15px',
                          cursor: 'pointer',
                          backgroundColor: selectedChatIndex === otherUser._id ? '#e6f7ff' : 'transparent', // Highlight selected chat

                        }}
                        onClick={() => handleChatClick(otherUser._id, otherUser)} // Handle chat click
                      >
                        {otherUser.Name}
                      </Menu.Item>
                    )
                  );
                })
              ) : (
                <Empty description="No recent chats" />
              )}
            </div>
          </Menu.SubMenu>
        </Menu>
      </div>
    </div>
  );
};

export default ChatSidebar;
